import { features } from '../pages/dashboards/dashboardFramework/helpers/features';

const INDICATOR_PATH_SEGMENTS: Record<string, string> = {
  [features.REAMS]: 'rent-navigator',
};

export const indicatorIdToPathSegment = (indicatorId: string) =>
  INDICATOR_PATH_SEGMENTS[indicatorId] ?? indicatorId;

export const pathSegmentToIndicatorId = (pathSegment: string): string => {
  if (!pathSegment) return pathSegment;

  const indicatorId = Object.keys(INDICATOR_PATH_SEGMENTS).find(
    (id) => INDICATOR_PATH_SEGMENTS[id] === pathSegment,
  );
  return indicatorId ?? pathSegment;
};

export const RENT_NAVIGATOR_BASE_PATH = `/optimize/${INDICATOR_PATH_SEGMENTS[features.REAMS]}`;

// Old Rent Navigator URL, kept as a redirect for bookmarks and email links
export const LEGACY_RENT_NAVIGATOR_BASE_PATH = `/optimize/${features.REAMS}`;
